import { useEffect } from 'react';
import { Items } from './items';
import { Images } from 'assets/images';
import { v4 as uuid } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import { selectHotOfferById } from 'store/offers/selector';
import ReactHtmlParser from 'react-html-parser';
import { offersAction } from 'store';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from 'utils/routeNames';
import {
  Container,
  TextBold,
  ToursByIdStyle,
  ToursByIdWrapper,
  HotOffersImage,
  OfferInformation,
  PriceWrapper,
  OfferPriceTitle,
  OfferPrice,
  StarsImage,
  OfferDescription,
  InformationBlok,
  LineAirStyle,
  SlideImageWrapper,
  Suggestion,
  ItemsWrapper,
  StrongText,
  HyperlinkText,
} from './styles';
import {
  CardText,
  SampleAnotherPage,
  SampleParagraph,
  SampleSpan,
} from 'containers/Requests/fragments/RequestsCountries/fragments/RequestsOffer/OfferItem/styled';

export const ToursById = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const hotOffer = useSelector(selectHotOfferById);

  const { id } = useParams();

  const navigateSuggestion = (id) => {
    navigate(`${ROUTES.TOURS_SUGGESTION}/${id}`);
  };

  useEffect(() => {
    dispatch(offersAction.getHotOffer(id));
  }, []);

  return (
    <Container>
      <ToursByIdStyle>
        <ToursByIdWrapper>
          <HotOffersImage src={hotOffer?.main_image} alt="hot-offers-image" />
          <OfferInformation>
            <PriceWrapper>
              <OfferPriceTitle>{hotOffer?.title}</OfferPriceTitle>
              <OfferPrice>$ {hotOffer?.price}</OfferPrice>
            </PriceWrapper>
            <StarsImage src={Images.stars} alt="stars" />
            <OfferDescription>
              <TextBold>Description:</TextBold>
              {ReactHtmlParser(hotOffer?.description)}
            </OfferDescription>
            <InformationBlok>
              <Items
                text="Country, City: "
                info={`${hotOffer?.country?.name},${hotOffer?.city?.name}`}
              />
              <Items text="Population: " info={`${hotOffer?.population}`} />
              {/* todo
              <Items text="Healthcare: " info="test" /> */}
              <Items text="Language: " info={`${hotOffer?.language}`} />
              <ItemsWrapper>
                <StrongText>Booking URL: </StrongText>
                <HyperlinkText
                  href={`${hotOffer?.booking_url}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {hotOffer?.booking_url}
                </HyperlinkText>
              </ItemsWrapper>

              <ItemsWrapper>
                <StrongText>Ticket URL: </StrongText>
                <HyperlinkText
                  href={`${hotOffer?.ticket_url}`}
                  target="_blank"
                  rel="noreferrer"
                >
                  {hotOffer?.ticket_url}
                </HyperlinkText>
              </ItemsWrapper>

              {hotOffer?.label?.map((label) => (
                <CardText key={uuid()} isLabel>
                  <SampleParagraph>{label.label_key}:</SampleParagraph>
                  <SampleSpan isLabel>
                    <SampleAnotherPage
                      href={label.label_value}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {label.label_value}
                    </SampleAnotherPage>
                  </SampleSpan>
                </CardText>
              ))}
              {/* todo */}
              {/* <Items text="Package Name: " info="Yerevan/Active" /> */}
            </InformationBlok>

            <LineAirStyle src={Images.lineAir} alt="lineAir" />
            {/*<IconWrapper>*/}
            {/*  <ShareTitle>Share:</ShareTitle>*/}
            {/*  {SocialMediaIconsData.map((element) => (*/}
            {/*    <LinkToWebsite*/}
            {/*      key={uuid()}*/}
            {/*      href={element.link}*/}
            {/*      target="_blank"*/}
            {/*      rel="noreferrer"*/}
            {/*    >*/}
            {/*      <SocialMediaIcon src={element.img} key={uuid()} />*/}
            {/*    </LinkToWebsite>*/}
            {/*  ))}*/}
            {/*</IconWrapper>*/}
          </OfferInformation>
        </ToursByIdWrapper>
        <SlideImageWrapper>
          {hotOffer?.suggestions?.map((suggestion) => (
            <Suggestion
              src={suggestion.main_image}
              alt="suggestion-image"
              key={suggestion.id}
              onClick={() => navigateSuggestion(suggestion.id)}
            />
          ))}
        </SlideImageWrapper>
      </ToursByIdStyle>
    </Container>
  );
};
